import customConnect from '../customConnect';
import { map } from '../map/map';
import { EVENTS_14, layer14, EVENTS_25, layer25 } from './assets';

const clickEvent = (e) => {
    map.forEachFeatureAtPixel(e.pixel, function (feature, clickLayer) {
        if (layer14 === clickLayer || layer25 === clickLayer) {
            const props = feature.getProperties();

            if (props.link) {
                window.open(props.link);
            }
        }
    });
}

const stateUpdateHandler = ({ enabled }) => {
    if (enabled === EVENTS_14) {
        map.removeLayer(layer25);
        map.addLayer(layer14);
        map.on('click', clickEvent);

    } else if (enabled === EVENTS_25) {
        map.removeLayer(layer14);
        map.addLayer(layer25);
        map.on('click', clickEvent);

    } else {
        map.removeLayer(layer14);
        map.removeLayer(layer25);
        map.un('click', clickEvent);
    }
}

export default function (store) {
	const mapStateToPropsRes = (state) => {
        const parent = state.mapData.data.filter(x => x.id === 'events');

        if (parent[0].childs.filter(x => x.id === 'events_14' && x.active).length > 0) {
            return {
                enabled: EVENTS_14
            }

        } else if (parent[0].childs.filter(x => x.id === 'events_25' && x.active).length > 0) {
            return {
                enabled: EVENTS_25
            }
        }

		return {
            enabled: false
		}
	}

	const mapDispatchToPropsRes = (dispatch) => {

	  return {
	    selectFeature: (data, group, zoomLvl) => {

	    },
	  }
	}

	customConnect(mapStateToPropsRes, mapDispatchToPropsRes, store, stateUpdateHandler);
}



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/memorialEvents/mapContainer.js